import React from 'react';

import { Box, InputSelect, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo, Link } from '@components';
import { rem } from '@helpers';

import { IntegratorForm } from './block';
import { useIntegratorDataHelper } from './integratorData.helper';

export const IntegratorDataPlaceholder: React.FC = () => {
	const {
		resources,
		buildIntegrators,
		selectedOneIntegrator,
		clickToCallAllInternationalDialingPhoneCodes,
		popupMenuIntegratorRef,
		handlePressSelectIntegrator,
	} = useIntegratorDataHelper();

	return (
		<>
			{clickToCallAllInternationalDialingPhoneCodes !== undefined && (
				<ComponentInfo name="IntegratorDataPlaceholder" type="placeholder">
					<Typography appearance="headline-200-02">{resources.title}</Typography>
					<Spacer vertical={rem(40)} />
					<Typography appearance="subtitle-100-03">{resources.corporateIntegrator}</Typography>
					<Spacer vertical={rem(24)} />
					<Box styles={{ width: rem(343) }}>
						<InputSelect
							mode="default"
							ref={popupMenuIntegratorRef}
							inputField={{ label: resources.corporate }}
							onPress={handlePressSelectIntegrator}
							popupMenu={{
								items: buildIntegrators,
								popupMenuHeight: { maxHeight: rem(264) },
								hideOnClick: true,
								zIndex: 10,
							}}
						/>
					</Box>
					{selectedOneIntegrator && <IntegratorForm />}
					<Spacer vertical={rem(32)} />
					<Box styles={{ width: '100%' }}>
						<Link redirectUrl={resources.link} target={'_blank'}>
							<Typography appearance={'body-75-03'} colorToken={'interaction-01-100'}>
								{resources.hasNotTechnicIntegrator}
							</Typography>
						</Link>
					</Box>
				</ComponentInfo>
			)}
		</>
	);
};
